<template>
    <div class="step4">
    </div>
</template>

<script>
export default {
    name: 'CourseStep4',
    components: {
        // Aquí puedes agregar los componentes que necesites
    },
    data() {
        return {
        // Aquí puedes definir tus datos reactivos
        };
    },
    methods: {
        // Aquí puedes definir tus métodos
    },
    mounted() {
        // Aquí puedes realizar acciones cuando el componente se monte
    }
}
</script>
<style>

</style>